import React from "react";
import { useLocation } from "react-router-dom";
import "./Footer.css";


const Footer = () => {
  const location = useLocation();
  return (
    <footer className="landing-footer">
      <div className="footer-top">
        <div className="footer-col">
          <h5>THRIVE</h5>
          <p>
            Your go-to platform for reporting and resolving campus issues.
          </p>
        </div>

        <div className="footer-col">
          <h5>Contact Us</h5>
          <p>Feel free to reach out for any queries or support.</p>

          <p>
            Email:
            <a href="mailto:administrativeofficer@vnrvjiet.in">
              administrativeofficer@vnrvjiet.in
            </a>
          </p>

          <p>Phone: +91-90471-11965</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} THRIVE. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;